<template>
  <div>
    <dl class="description-list grid grid-cols-2 gap-4 max-w-sm text-base mt-4 md:mt-0">
      <dt>{{ $t('text.account.orderHistory.orderNumber') }}</dt>
      <dd>{{ orderData.code }}</dd>

      <dt>{{ $t('text.poNumber') }}</dt>
      <dd>{{ orderData.details.customerPo }}</dd>

      <dt>{{ $t('text.orderDate') }}</dt>
      <dd>{{ orderData.details.orderDate }}</dd>

      <dt>{{ $t('text.requestDate') }}</dt>
      <dd>{{ orderData.details.requestedDate }}</dd>

      <dt>{{ $t('text.placedBy') }}</dt>
      <dd>{{ orderData.details.placedBy }}</dd>

      <dt>{{ $t('text.paymentTerms') }}</dt>
      <dd>{{ orderData.details.paymentDetails.paymentTerms }}</dd>

      <template v-if="orderData.details.paymentDetails.maskedCreditCardNumber">
        <dt>{{ $t('payment.cardNumber') }}</dt>
        <dd>{{ orderData.details.paymentDetails.maskedCreditCardNumber }}</dd>
      </template>

      <dt>{{ $t('text.account.orderHistory.orderStatus') }}</dt>
      <dd>{{ orderData.details.orderStatus }}</dd>

      <dt>{{ $t('text.itemsShipped') }}</dt>
      <dd>{{ orderData.details.shippedQuantity }}</dd>

      <dt>{{ $t('text.account.paymentDetails.billingAddress') }}</dt>
      <dd>
        <div v-show="orderData.billingAddress.billTo">{{ orderData.billingAddress.billTo }}</div>
        <div v-show="orderData.billingAddress.billingNumber">{{ orderData.billingAddress.billingNumber }}</div>
        <div v-show="orderData.billingAddress.line1">{{ orderData.billingAddress.line1 }}</div>
      </dd>
    </dl>
    <dl
      v-if="orderData.details.isConsumerDelivery && orderData.consumerDetails"
      class="description-list grid grid-cols-2 gap-4 max-w-sm text-base"
    >
      <dt>{{ $t('orderDetails.B2B.consumerName') }}</dt>
      <dd>{{ orderData.consumerDetails.name }}</dd>

      <dt>{{ $t('text.address.phone') }}</dt>
      <dd>{{ orderData.consumerDetails.phoneNumber }}</dd>

      <dt>{{ $t('text.address.email') }}</dt>
      <dd>{{ orderData.consumerDetails.email }}</dd>

      <dt>{{ $t('text.deliveryAddress') }}</dt>
      <dd>
        <div v-show="orderData.consumerDetails.line1">{{ orderData.consumerDetails.line1 }}</div>
        <div v-show="orderData.consumerDetails.line2">{{ orderData.consumerDetails.line2 }}</div>
        <div v-show="orderData.consumerDetails.town">{{ orderData.consumerDetails.town }}</div>
        <div v-show="orderData.consumerDetails.regionIso">{{ orderData.consumerDetails.regionIso }}</div>
        <div v-show="orderData.consumerDetails.postalCode">{{ orderData.consumerDetails.postalCode }}</div>
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  props: {
    orderData: {
      type: Object,
      required: true,
      default: () => null,
    },
  },
};
</script>
